import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/app/login',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

export function logout () {
  return request({
    url: '/app/logout',
    method: 'post'
  })
}

export function register(data) {
  return request({
    url: '/app/register',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

export function getInfo(data) {
  return request({
    url: '/app/user/getInfo',
    method: 'get',
    data: data
  })
}

export function getRandomImgList (data) {
  return request({
    url: '/app/user/getRandomImg',
    method: 'get',
    data: data
  })
}

export function getLevelList (data) {
  return request({
    url: '/app/user/getLevelList',
    method: 'get',
    data: data
  })
}

export function getFinancial () {
  return request({
    url: '/app/config/financial',
    method: 'get'
  })
}

export function getCardInfo () {
  return request({
    url: '/app/bankCard/getCardInfo',
    method: 'get'
  })
}

export function bindCardInfo (data) {
  return request({
    url: '/app/bankCard/bind',
    method: 'post',
    data: data
  })
}

export function walletPayoutAdd (data) {
  return request({
    url: '/app/walletPayout/add',
    method: 'post',
    data: data
  })
}

export function walletPayoutList () {
  return request({
    url: '/app/walletPayout/list',
    method: 'get'
  })
}

export function getLogs () {
  return request({
    url: '/app/bankCard/getLogs',
    method: 'get'
  })
}

// 重置登录密码
export function resetPwd (data) {
  return request({
    url: '/app/user/resetPwd',
    method: 'put',
    data: data
  })
}

// 重置登录密码
export function resetWalletPwd (data) {
  return request({
    url: '/app/user/resetWalletPwd',
    method: 'put',
    data: data
  })
}


// 我的公告列表
export function getNoticeList () {
  return request({
    url: '/app/notice/noticeList',
    method: 'get'
  })
}

// 修改用户详情
export function updateUserInfo (data) {
  return request({
    url: '/app/user',
    method: 'put',
    data: data
  })
}
